import { useState } from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { camelCase } from '../Common/Util';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { PositionOffCanvas } from '../Canvas/PositionOffcanvas';
import { ChartOffCanvas } from '../Canvas/ChartOffcanvas';
import { SelfOffCanvas } from '../Canvas/SelfOffcanvas';
import { MenuDropDown } from './Common/AppUtil';

export function EventsMenu({userData, clientData, handleMenu}) {
  const [showMenu, setShowMenu] = useState(false);
  const [menuArray, setMenuArray] = useState([true,false,false,false,false,false,false,false,false,false,false]);
  const [eventAnalyser, setEventAnalyser] = useState(true);
  const [destinyAnalyser, setDestinyAnalyser] = useState(false);
  const [prosperityChart, setProsperityChart] = useState(false);
  const [timeChart, setTimeChart] = useState(false);
  const [dba, setDba] = useState(false);
  const [comment, setComment] = useState(false);
  const [birthTimeCorrection, setBirthTimeCorrection] = useState(false);
  const [positionPopup, setPositionPopup] = useState(false);
  const [chartPopup, setChartPopup] = useState(false);
  const [selfPopup, setSelfPopup] = useState(false);
  const setMethod = { setEventAnalyser, setDestinyAnalyser, setProsperityChart,setTimeChart,setDba,setComment,setBirthTimeCorrection};
  const handleShowMenu = ()=>{setShowMenu(!showMenu);}
  const handlePositionPopupChange=()=>{setPositionPopup(!positionPopup);}
  const handleChartPopupChange=()=>{setChartPopup(!chartPopup);}
  const handleSelfPopupChange=()=>{setSelfPopup(!selfPopup);}

  const handleChange=(event)=>{
    for (let key in setMethod) {
      if (setMethod.hasOwnProperty(key)) {
        setMethod[key](false);
      }
    }
    const name = event.currentTarget.id;
    const methodName = "set"+camelCase(name);
    setMethod[methodName](event.currentTarget.checked);
    const tempMenuArray = [...menuArray];
    for(var i=0;i<menuArray.length;i++) {
       tempMenuArray[i]=false;
    }
    tempMenuArray[event.currentTarget.value]=event.currentTarget.checked;
    setMenuArray(tempMenuArray);
    handleMenu(tempMenuArray);
    setShowMenu(false); 
  }

  handleMenu(menuArray);

  return (
    <>
    { userData===null || userData===undefined || clientData===null || clientData===undefined ?<></>:
      <div class="m-0 p-0 noprint" >
        <div class="row m-0 p-0">
          <div class="col-12 m-0 p-0">
            <Navbar expand="md" className="m-0 p-0 bg-light">
              <MenuDropDown title="Advanced Stellar System" id={userData.id} runningId={userData.runningId}/>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-1 m-0 p-0 " onClick={()=>handleShowMenu()} />  
              <Navbar.Collapse id="basic-navbar-nav" className="m-0 p-0 "  in={showMenu} >
                <Nav className="m-0 p-0"  >
                  <div class="m-0 p-0">
                <ToggleButton className="m-0 me-1 p-1 border-1" id="eventAnalyser" type="checkbox" variant="outline-transparent" checked={eventAnalyser} value="0" onChange={(e) => handleChange(e)}>Event Analyser</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="destinyAnalyser" type="checkbox" variant="outline-transparent" checked={destinyAnalyser} value="1" onChange={(e) => handleChange(e)}>Destiny Analyser</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="prosperityChart" type="checkbox" variant="outline-transparent" checked={prosperityChart} value="2" onChange={(e) => handleChange(e)}>Prosperity Analyser</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="timeChart" type="checkbox" variant="outline-transparent" checked={timeChart} value="3" onChange={(e) => handleChange(e)}>Time Analyser</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="dba" type="checkbox" variant="outline-transparent" checked={dba} value="9" onChange={(e) => handleChange(e)}>DBA</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="comment" type="checkbox" variant="outline-transparent" checked={comment} value="4" onChange={(e) => handleChange(e)}>Report</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="birthTimeCorrection" type="checkbox" variant="outline-transparent" checked={birthTimeCorrection} value="5" onChange={(e) => handleChange(e)}>Birth Time Correction</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="chartPopup" type="checkbox" variant="outline-transparent" checked={chartPopup} value="3" onChange={(e) => handleChartPopupChange(e)}>Natal Chart</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="positionPopup" type="checkbox" variant="outline-transparent" checked={positionPopup} value="3" onChange={(e) => handlePositionPopupChange(e)}>Natal Position</ToggleButton>
                <ToggleButton className="m-0 me-1 p-1 border-1" id="selfPopup" type="checkbox" variant="outline-transparent" checked={selfPopup} value="3" onChange={(e) => handleSelfPopupChange(e)}>Self Significator</ToggleButton>
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
            <PositionOffCanvas showpopup={positionPopup} handlePopup={handlePositionPopupChange} userData={userData}/>
            <ChartOffCanvas showpopup={chartPopup} handlePopup={handleChartPopupChange} userData={userData} clientData={clientData}/>
            <SelfOffCanvas showpopup={selfPopup} handlePopup={handleSelfPopupChange} userData={userData} clientData={clientData}/>
          </div>
        </div>
      </div>
      }
    </>
  );
}
